export default "__VITE_ASSET__DeP3j999__"